import React from 'react';

import UniversalSelect from '../../../common/components/universal_select';

export default class MobileCategoriesSelect extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      current_category: this.currentCategory(),
      select_title: ' ',
      class_name: 'mobile-categories',
      options: this.options()
    };
  }

  render() {
    return (
      <UniversalSelect
        options_list={this.state.options}
        title={this.state.select_title}
        class_name={this.state.class_name}
        handleChange={this.handleSelect}
        default_option={this.state.current_category}
        fold_on_input_click={true}
        close_on_select={true}
      />
    );
  }

  handleSelect(choice) {
    window.location.pathname = `/blog/${choice.value}`;
  }

  options() {
    return this.props.categories.map(category => {
      return { name: category.name, value: category.slug };
    });
  }

  currentCategory() {
    const categories = this.props.categories;
    const current_cat_id = this.props.current_category_id;
    const filtered_categories = categories.filter(category => {
      return category.id === current_cat_id;
    });
    return {
      name: filtered_categories[0].name,
      value: filtered_categories[0].slug
    };
  }
}



// WEBPACK FOOTER //
// ./app/javascript/pages/blog/components/mobile_categories_select.jsx